import {useState, useEffect, useRef} from 'react';
import {useInterval} from '../common/app_common.js';
import {Title} from '../common/component_common.js';
import {getApiSystemStatus, postApiSystemStatusClear} from '../common/fetch_api/api_common.js';
import {BsExclamationCircle, BsEraser} from 'react-icons/bs';
import Button from 'react-bootstrap/Button';
import {InfoModal} from './host_status/modals.js';
import '.././common/css/system.css';

const PageHostStatus = () => {

    const [update, setUpdate] = useState(false);

    const [containerStats, setContainerStats] = useState(null);
    const [apiStats, setApiStats] = useState(null);
    const [systemStats, setSystemStats] = useState(null);
    const [siteManager, setSiteManager] = useState(null);
    const [systemSeverity, setSystemSeverity] = useState(null);
    const [systemWarningList, setSystemWarningList] = useState(null);

    const [dataInfo, setDataInfo] = useState(null);
    const [modalInfo, setModalInfo] = useState(false);
    const closeModalInfo = () => setModalInfo(false);

    function getUsage(type)
    {
        if(!systemStats) return '';

        if( type === 'cpu')
        {
            return `${parseFloat(systemStats.cpu.usage).toFixed(1)} ${systemStats.cpu.unit}`;
        }
        else if( type === 'mem')
        {
            return `${parseFloat(systemStats.mem.usage).toFixed(1)}% (${parseFloat(systemStats.mem.used).toFixed(2)} ${systemStats.mem.unit})`;
        }
        else if( type === 'disk')
        {
            let diskStat = systemStats.disk.filter((x) => {return x.path === '/'});
            return diskStat?`${parseFloat(diskStat[0].usage).toFixed(1)}% (${parseFloat(diskStat[0].used).toFixed(2)} ${diskStat[0].unit})`:'';
        }
    }

    function getServerStatusText()
    {
        if( !systemSeverity ) return '';
        if( systemSeverity.includes('warning') )
        {
            if( systemWarningList )
            {
                return `Warning (${[...systemWarningList]})`;
            }
        }

        return systemSeverity;
    }

    function getServerStatusColor()
    {
        if( !systemSeverity ) return '';
        if( systemSeverity.includes('warning') || 1)
        {
            return 'text-warning';
        }
    }

    function getSiteManagerText(type)
    {
        if( !siteManager ) return '';
        return siteManager[type];
    }

    function geApiText(type)
    {
        if( !apiStats ) return '';
        return apiStats[type];
    }

    function getDockerText(type)
    {
        if( !containerStats || !containerStats.hasOwnProperty(type) || !containerStats[type].hasOwnProperty('healthy') ) return '';
        return containerStats[type].healthy === 1 ? 'Running' : 'Stopped';
    }

    function getDockerColor(type)
    {
        if( containerStats && containerStats.hasOwnProperty(type) && containerStats[type].healthy === 0 )
        {
            return 'text-warning';
        }
    }

    function onClickDocker(type)
    {
        if( !containerStats && containerStats.hasOwnProperty(type) ) return;

        setDataInfo({name: type, data: containerStats[type]});
        setModalInfo(true);
    }

    function runUpdate()
    {
        setUpdate(!update);
    }

    function getState(key)
    {
        let result = {val: null, state: null};
        
        switch(key)
        {
            case 'containerStats' :
                result = {val: containerStats, state: setContainerStats};
                break;
            case 'apiStats' :
                result = {val: apiStats, state: setApiStats};
                break;
            case 'systemStats' :
                result = {val: systemStats, state: setSystemStats};
                break;
            case 'siteManager' :
                result = {val: siteManager, state: setSiteManager};
                break;
            case 'systemSeverity' :
                result = {val: systemSeverity, state: setSystemSeverity};
                break;
            case 'systemWarningList' :
                result = {val: systemWarningList, state: setSystemWarningList};
                break;
            default:break;
        }

        return result;
    }

    useEffect( () => {

        Promise.resolve( getApiSystemStatus() )
        .then( data => {
            if( data )
            {
                Object.keys(data).forEach( (key, idx) => {
                    let pre = getState(key);
                    let preVal = JSON.stringify(pre.val);
                    let preState = pre.state;
                    let curVal = JSON.stringify(data[key]);

                    if( !pre.state )
                    {
                        // console.log('! null', pre, key);
                        return;
                    }

                    if( preVal.length && preVal !== curVal )
                    {
                        preState(data[key]);

                        if( key === 'containerStats' && containerStats && dataInfo && dataInfo.name.length )
                        {
                            if( containerStats.hasOwnProperty(dataInfo.name) )
                            {
                                setDataInfo({name: dataInfo.name, data: containerStats[dataInfo.name]});
                            }
                        }
                    }
                });
            }
        });

    }, [update]);

    useInterval(() =>
    {
        runUpdate();
    }, 5000 );

    return (
        <>
            <Title title='Host Status'></Title>
            <div className="section system-area">
                <div className="server-area">
                    <div className="section-title mt-3">Server System</div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box">CPU Usage</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-8 col-8 ps-1">
                            <input className="form-control input-box" type="text" value={getUsage('cpu')} readOnly/>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box">MEM Usage</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-8 col-8 ps-1">
                            <input className="form-control input-box" type="text" value={getUsage('mem')} readOnly/>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box">DISK Usage</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-8 col-8 ps-1">
                            <input className="form-control input-box" type="text" value={getUsage('disk')} readOnly/>
                        </div>
                    </div>
                </div>
                <div className="manager-area">
                    <div className="section-title mt-3">Alert</div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box">Server Status</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-8 col-8 ps-1">
                            <input className={`form-control input-box ${getServerStatusColor()}`} type="text" value={getServerStatusText()} readOnly/>
                        </div>
                    </div>
                </div>
                <div className="manager-area">
                    <div className="section-title mt-3">Site Manager</div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box">Edge Count</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-8 col-8 ps-1">
                            <input className="form-control input-box" type="text" value={getSiteManagerText('edgeCount')} readOnly/>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box">Site Count</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-8 col-8 ps-1">
                            <input className="form-control input-box" type="text" value={getSiteManagerText('siteCount')} readOnly/>
                        </div>
                    </div>
                </div>
                <div className="api-area">
                    <div className="section-title mt-3">API</div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box">Request Count</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-7 col-7 ps-1">
                            <input className="form-control input-box" type="text" value={geApiText('requestCount')} readOnly/>
                        </div>
                        <div className="col-1">
                            <Button variant='primary' className="btn btn-icon" onClick={postApiSystemStatusClear}><BsEraser /></Button>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box">Metrics Count</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-8 col-8 ps-1">
                            <input className="form-control input-box" type="text" value={geApiText('metricsCount')} readOnly/>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box">Metrics Bitrate</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-8 col-8 ps-1">
                            <input className="form-control input-box" type="text" value={`${(geApiText('metricsBitrate')/1000000).toFixed(3)} Mbps`} readOnly/>
                        </div>
                    </div>
                </div>
                <div className="docker-area">
                    <div className="section-title mt-3">Docker Service State</div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box">Prometheus</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-7 col-7 ps-1">
                            <input className={`form-control input-box ${getDockerColor('prometheus')}`} type="text" value={`${getDockerText('prometheus')}`} readOnly/>
                        </div>
                        <div className="col-1">
                            <Button variant='primary' className="btn btn-icon" data-bs-toggle="tooltip" title="Service Infomation" onClick={() => {onClickDocker('prometheus')}}><BsExclamationCircle /></Button>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box">InfluxDB</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-7 col-7 ps-1">
                            <input className={`form-control input-box ${getDockerColor('influxdb')}`} type="text" value={`${getDockerText('influxdb')}`} readOnly/>
                        </div>
                        <div className="col-1">
                            <Button variant='primary' className="btn btn-icon" data-bs-toggle="tooltip" title="Service Infomation" onClick={() => {onClickDocker('influxdb')}}><BsExclamationCircle /></Button>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box">Pushgateway-m</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-7 col-7 ps-1">
                            <input className={`form-control input-box ${getDockerColor('pushgateway-m')}`} type="text" value={`${getDockerText('pushgateway-m')}`} readOnly/>
                        </div>
                        <div className="col-1">
                            <Button variant='primary' className="btn btn-icon" data-bs-toggle="tooltip" title="Service Infomation" onClick={() => {onClickDocker('pushgateway-m')}}><BsExclamationCircle /></Button>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box">Pushgateway-s</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-7 col-7 ps-1">
                            <input className={`form-control input-box ${getDockerColor('pushgateway-s')}`} type="text" value={`${getDockerText('pushgateway-s')}`} readOnly/>
                        </div>
                        <div className="col-1">
                            <Button variant='primary' className="btn btn-icon" data-bs-toggle="tooltip" title="Service Infomation" onClick={() => {onClickDocker('pushgateway-s')}}><BsExclamationCircle /></Button>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box">Pushgateway-t</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-7 col-7 ps-1">
                            <input className={`form-control input-box ${getDockerColor('pushgateway-t')}`} type="text" value={`${getDockerText('pushgateway-t')}`} readOnly/>
                        </div>
                        <div className="col-1">
                            <Button variant='primary' className="btn btn-icon" data-bs-toggle="tooltip" title="Service Infomation" onClick={() => {onClickDocker('pushgateway-t')}}><BsExclamationCircle /></Button>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box">AlertManager</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-7 col-7 ps-1">
                            <input className={`form-control input-box ${getDockerColor('alertmanager')}`} type="text" value={`${getDockerText('alertmanager')}`} readOnly/>
                        </div>
                        <div className="col-1">
                            <Button variant='primary' className="btn btn-icon" data-bs-toggle="tooltip" title="Service Infomation" onClick={() => {onClickDocker('alertmanager')}}><BsExclamationCircle /></Button>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box">Loki</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-7 col-7 ps-1">
                            <input className={`form-control input-box ${getDockerColor('loki')}`} type="text" value={`${getDockerText('loki')}`} readOnly/>
                        </div>
                        <div className="col-1">
                            <Button variant='primary' className="btn btn-icon" data-bs-toggle="tooltip" title="Service Infomation" onClick={() => {onClickDocker('loki')}}><BsExclamationCircle /></Button>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box">Promtail</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-7 col-7 ps-1">
                            <input className={`form-control input-box ${getDockerColor('promtail')}`} type="text" value={`${getDockerText('promtail')}`} readOnly/>
                        </div>
                        <div className="col-1">
                            <Button variant='primary' className="btn btn-icon" data-bs-toggle="tooltip" title="Service Infomation" onClick={() => {onClickDocker('promtail')}}><BsExclamationCircle /></Button>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box">License</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-7 col-7 ps-1">
                            <input className={`form-control input-box ${getDockerColor('license')}`} type="text" value={`${getDockerText('license')}`} readOnly/>
                        </div>
                        <div className="col-1">
                            <Button variant='primary' className="btn btn-icon" data-bs-toggle="tooltip" title="Service Infomation" onClick={() => {onClickDocker('license')}}><BsExclamationCircle /></Button>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box">RabbitMQ</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-7 col-7 ps-1">
                            <input className={`form-control input-box ${getDockerColor('rabbitmq')}`} type="text" value={`${getDockerText('rabbitmq')}`} readOnly/>
                        </div>
                        <div className="col-1">
                            <Button variant='primary' className="btn btn-icon" data-bs-toggle="tooltip" title="Service Infomation" onClick={() => {onClickDocker('rabbitmq')}}><BsExclamationCircle /></Button>

                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box">Redis</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-7 col-7 ps-1">
                            <input className={`form-control input-box ${getDockerColor('redis')}`} type="text" value={`${getDockerText('redis')}`} readOnly/>
                        </div>
                        <div className="col-1">
                            <Button variant='primary' className="btn btn-icon" data-bs-toggle="tooltip" title="Service Infomation" onClick={() => {onClickDocker('redis')}}><BsExclamationCircle /></Button>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box">Postgres</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-7 col-7 ps-1">
                            <input className={`form-control input-box ${getDockerColor('postgres')}`} type="text" value={`${getDockerText('postgres')}`} readOnly/>
                        </div>
                        <div className="col-1">
                            <Button variant='primary' className="btn btn-icon" data-bs-toggle="tooltip" title="Service Infomation" onClick={() => {onClickDocker('postgres')}}><BsExclamationCircle /></Button>
                        </div>
                    </div>
                </div>
            </div>
            <InfoModal info={dataInfo} show={modalInfo} handleClose={closeModalInfo}></InfoModal>
        </>
    )
}

export default PageHostStatus;